import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/SEOHead";
import { FloatingWhatsApp } from "@/components/ui/floating-whatsapp";
import { Shield, Award, Users, Target } from "lucide-react";
import { cn } from "@/lib/utils";

const About = () => {
  const values = [
    {
      icon: Shield,
      title: "Seguridad",
      description: "Ofrecemos productos confiables y de marcas reconocidas para proteger lo que más importa",
    },
    {
      icon: Award,
      title: "Calidad",
      description: "Solo trabajamos con marcas reconocidas y productos de la más alta calidad",
    },
    {
      icon: Users,
      title: "Asesoría Experta",
      description: "Te ayudamos a elegir la mejor solución tecnológica para tus necesidades",
    },
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title="Sobre Nosotros"
        description="Conocé a Tekton, tu tienda de tecnología de confianza en Costa Rica. Cámaras de seguridad, equipos de cómputo y soluciones tecnológicas."
        keywords="sobre nosotros, tienda tecnología, Tekton, Costa Rica, historia"
      />
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <div className="bg-primary text-white py-12">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold mb-2">Sobre Nosotros</h1>
            <p className="text-white/80">
              Toneladas de tecnología para tu hogar y negocio
            </p>
          </div>
        </div>

        {/* Story Section */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold mb-6">Nuestra Historia</h2>
              <div className="space-y-4 text-muted-foreground leading-relaxed">
                <p>
                  Tekton nació con la misión de brindar soluciones tecnológicas de calidad a 
                  hogares y empresas en Costa Rica. Nos especializamos en cámaras de seguridad, 
                  equipos de cómputo y accesorios tecnológicos.
                </p>
                <p>
                  Cada producto que ofrecemos es cuidadosamente seleccionado por nuestro equipo
                  de expertos, garantizando que recibas solo lo mejor en tecnología y servicio.
                </p>
                <p>
                  Creemos que la tecnología debe ser accesible y fácil de usar. Por eso, 
                  ofrecemos asesoría personalizada para ayudarte a encontrar la solución 
                  perfecta para tus necesidades.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-12 bg-muted">
          <div className="container mx-auto px-4">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">Nuestros Valores</h2>
            
            <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
              {values.map((value) => (
                <div 
                  key={value.title}
                  className={cn(
                    "bg-card rounded-lg border border-border p-6 text-center",
                    "hover:shadow-card transition-shadow duration-300"
                  )}
                >
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-lg gradient-primary mb-4">
                    <value.icon className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-lg font-bold mb-2">{value.title}</h3>
                  <p className="text-muted-foreground text-sm">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-lg gradient-accent mb-4">
                <Target className="h-7 w-7 text-white" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold mb-4">Nuestra Misión</h2>
              <p className="text-muted-foreground leading-relaxed">
                Proporcionar soluciones tecnológicas de excelencia que mejoren la seguridad, 
                productividad y conectividad de nuestros clientes. Aspiramos a ser el 
                referente de confianza en tecnología, combinando conocimiento experto, 
                productos premium y un servicio al cliente excepcional.
              </p>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-12 bg-primary text-white">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">¿Por qué elegirnos?</h2>
              <p className="text-white/80 mb-6">
                En Tekton no solo vendemos tecnología, construimos relaciones de confianza. 
                Cada cliente es único y merece una atención personalizada.
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                {["Precios competitivos", "Soporte post-venta", "Instalación profesional", "Envío rápido"].map((item) => (
                  <span 
                    key={item}
                    className="px-4 py-2 rounded-full bg-white/20 text-sm font-medium"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default About;
